import React from 'react'

import Hero from '../components/Hero';
import Features from '../components/Features';

export default function Homepage() {
  return (
    <>
    <Hero />
    <Features />
    </>
  )
}
